import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { repeat } from 'lit/directives/repeat.js';
import type { Banner } from '../../../app/package/base/cms/package/cms-domain';
import style from './ui-slider-controls.css?inline';

const CName = 'ui-slider-controls';

@customElement(CName)
export class UISliderControls extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: Array }) banners: Banner[] = [];
  @property({ type: Boolean }) allowAnimation = false;
  @property({ type: Number }) animationDuration: number;
  @property({ type: Number }) currentIndex: number;
  @property() buttonClickCb?: (key: number) => void;
  @property({ type: String }) class = '';

  render() {
    // to avoid content shift even if we have less than 2 banners render the empty wrapper
    return html`
      ${!this.banners || this.banners.length < 2 ? this._renderEmptyWrapper() : this._renderControlButtons()}
    `;
  }

  private _renderEmptyWrapper() {
    return html`<div class="ui-slider-controls"></div>`;
  }

  private _renderControlButtons() {
    const getClassList = (key: number) => {
      return classMap({
        'ui-slider-controls__loader': true,
        'ui-slider-controls__loader--active': key === this.currentIndex && this.allowAnimation,
      });
    };

    return html`
      <div class="ui-slider-controls">
        ${repeat(
          this.banners,
          (_, key) => key,
          (_, key) =>
            html`<button class="ui-slider-controls__button" @click=${() => this.buttonClickCb?.(key)} aria-label=${'Slide'}>
              <div
                data-key=${`${key}-${this.allowAnimation}`}
                style="animation-duration: ${this.animationDuration}s"
                class=${getClassList(key)}
              ></div>
            </button>`,
        )}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UISliderControls;
  }
}
